import React from 'react'
import styles from "./Profile.module.scss"
import Pagination from "components/shared/pagination/Pagination";
import { NewTable } from 'components/shared/commonTable/Table';
import { useNavigate } from 'react-router-dom';
const Devices = () => {
    const navigate = useNavigate()
    const data = [
        {
            Device: 'Apartment Audit Form',
            Date: "Novermber 7,2024"

        },
        {
            Device: 'Apartment Audit Form',
            Date: "Novermber 7,2024"

        }, {
            Device: 'Apartment Audit Form',
            Date: "Novermber 7,2024"

        }, {
            Device: 'Apartment Audit Form',
            Date: "Novermber 7,2024"

        }, {
            Device: 'Apartment Audit Form',
            Date: "Novermber 7,2024"

        },

    ]

    const column = [
        {
            name: "Device Name",
            // width: "180px",
            selector: row => row.Device
        },
        {
            name: "Date Created",
            // width: "165px",
            selector: row => row.Date
        },
    ];

    const handlePagination = (e) => {
        // console.log('e', e)
    }

    const handlePerPage = (e) => {
        const value = parseInt(e?.target?.value);
        // dispatch(
        //   getBranchList({
        //     pageNo: 1,
        //     pageSize: value,
        //     search: searchTerm
        //   })
        // )
        // dispatch(setPageSize(value));
        // dispatch(setPageNo(1));
        // dispatch(
        //   getProjectsList({
        //     search: searchTerm,
        //     pageNo: 1,
        //     pageSize: value,
        //   })
        // );
    };

    const renderPaginationComponent = () => {
        let param = {
            currentPage: 1,
            rowsPerPage: 25,
            total: 100,
        };

        return (
            <Pagination
                store={param}
                handlePerPage={handlePerPage}
                handlePagination={handlePagination}
            />
        );
    };



    return (
        <div className={styles.dataContainer}>
            <NewTable
                columns={column}
                data={data}
            // onRowClicked={
            //     () => {
            //         navigate("/announcements/123")
            //     }
            // }
            />
        </div>
    )
}

export default Devices
